import { render } from "./TrackingID.vue?vue&type=template&id=8ed53e04&ts=true"
import script from "./TrackingID.vue?vue&type=script&lang=ts"
export * from "./TrackingID.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__